export enum TenderType {
  None = 'None',
  Cash = 'Cash',
  CreditDebit = 'CreditDebit',
  Voucher = 'Voucher',
  Cheque = 'Cheque',
  Check = 'Check',
  PointsTender = 'PointsTender',
  GiftCard = 'GiftCard',
  Mobile = 'Mobile',
  Rounding = 'Rounding',
  Reward = 'Reward',
  ElectronicVoucher = 'ElectronicVoucher',
  WicCheck = 'WicCheck',
  WicCvv = 'WicCvv',
  SmartWic = 'SmartWIC',
  StoredValue = 'StoredValue',
  Ewic = 'Ewic',
  CheckWithFee = 'CheckWithFee,',
}
